(() => {
    class TestTargetSourceModalController {
        constructor(
            $scope,
            $uibModalInstance,
            $timeout,
            CampaignDesignerService,
            source,
            brandId,
            testStoreId,
            proceed,
            failed
        ) {
            this._campaignDesignerService = CampaignDesignerService;
            this._timeout = $timeout;
            this._scope = $scope;
            this._modalInstance = $uibModalInstance;
            this.proceed = proceed;
            this.failed = failed;
            this.source = source;
            this.brandId = brandId;
            this.testStoreId = testStoreId;
            this.executeTest();
            $scope.confirm = this.confirm.bind(this);

            $scope.cancel = function () {
                $uibModalInstance.close(false);
            };
        }

        confirm() {
            if (this._scope.busyTesting) {
                return;
            }
            this._modalInstance.close(true);
            if (!this._scope.isBlockingFailure) {
                this.proceed();
                return;
            }
            this.failed();
        }

        async executeTest() {
            try {
                this._scope.busyTesting = true;
                const result = await this._campaignDesignerService.testTargetSource(
                    this.source,
                    this.brandId,
                    this.testStoreId);
                const totalCustomers = this.getParameterCaseInsensitive(result.data, "totalcustomers");
                if (totalCustomers >= 0) {
                    this._scope.isBlockingFailure = false;
                    this._scope.customerCount = totalCustomers;
                    this._scope.isTestSuccessful = totalCustomers > 0;
                    if (!this._scope.isTestSuccessful) {
                        this._scope.errorMessage = "Target source returned 0 customers for your selection";
                    }
                } else {
                    this._scope.isBlockingFailure = true;
                    this._scope.errorMessage = result.data.Reason;
                }
            } catch (e) {
                this._scope.isTestSuccessful = false;
                this._scope.isBlockingFailure = true;
                this._scope.errorMessage = e.data.message;
            } finally {
                this._scope.busyTesting = false;
                this._scope.$apply();
            }
        }

        getParameterCaseInsensitive(object, key) {
            return object[Object.keys(object)
                .find(k => k.toLowerCase() === key.toLowerCase())
                ];
        }
    }

    angular
        .module("dashboard")
        .controller("TestTargetSourceModalController", [
            "$scope",
            "$uibModalInstance",
            "$timeout",
            "CampaignDesignerService",
            "source",
            "brandId",
            "testStoreId",
            "proceed",
            "failed",
            TestTargetSourceModalController
        ]);
})();
